import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["inert"]
const _hoisted_2 = { class: "topic-field" }
const _hoisted_3 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TopicSearch = _resolveComponent("TopicSearch")
  const _component_TrackerButtongroup = _resolveComponent("TrackerButtongroup")
  const _component_TrackerSegment = _resolveComponent("TrackerSegment")
  const _component_TrackerTextarea = _resolveComponent("TrackerTextarea")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", {
    class: "add-tracker",
    inert: $data.saving
  }, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, "Track topic", -1 /* HOISTED */)),
    _createVNode(_component_ScrollBar, {
      class: "settings",
      "bar-x-offset": "-2rem"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, [
            _createTextVNode("Topic "),
            _createElementVNode("span", { class: "required" }, "*")
          ], -1 /* HOISTED */)),
          _createVNode(_component_TopicSearch, {
            ref: "topic",
            modelValue: $data.topic,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.topic) = $event)),
            required: "",
            "hide-followed": "",
            placeholder: "e.g. 5g monetization"
          }, null, 8 /* PROPS */, ["modelValue"])
        ]),
        _createVNode(_component_TrackerSegment, {
          title: "TRACKER SENSITIVITY",
          tooltip: "signal_sensitivity"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TrackerButtongroup, {
              modelValue: $data.tracker_focus,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.tracker_focus) = $event)),
              options: $data.SENSITIVITY
            }, null, 8 /* PROPS */, ["modelValue", "options"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_TrackerSegment, {
          title: "EMAIL ALERTS",
          tooltip: "email_notifications"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TrackerButtongroup, {
              modelValue: $data.tracker_alerts,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.tracker_alerts) = $event)),
              options: $data.ALERTS
            }, null, 8 /* PROPS */, ["modelValue", "options"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_TrackerSegment, {
          title: "WHAT SHOULD WE WATCH FOR?",
          tooltip: "topic_customize_tracking"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TrackerTextarea, {
              modelValue: $data.focus_on,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.focus_on) = $event)),
              title: "Focus tracking on:",
              placeholder: "e.g. product launches and partnerships"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_Divider, { m: "0 -2.4rem 2.4rem" }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        class: "delete-button",
        onClick: _cache[4] || (_cache[4] = $event => (_ctx.$dispatch('cancel')))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("Cancel")
        ])),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_save,
        onClick: $options.onSave
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("Start tracking")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}